
import { defineComponent } from 'vue'
import KnHint from '@/components/UI/KnHint.vue'
export default defineComponent({
    name: 'lovs-management-hint',
    components: { KnHint }
})
